<template>
  <div id="app">
    <keep-alive :include="['bindCard', 'bindAccount', 'bankCardTabs']">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "App",
  created() {
    // SDK埋点回调方法
    window.reportSDKCallback = (result) => {
      console.log(result)
    }
  }
}
</script>
<style src="@/assets/css/reset.css"></style>
<style src="@/assets/css/common.css"></style>
<style>
html, body{
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  font-size: 28px;
  font-weight: 400;
  color: #1b3155;
  font-family: Roboto, Roboto-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* toast弹层 */
.van-toast.van-toast--text{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  transform: none;
  border-radius: 0;
}
.van-toast.van-toast--text .van-toast__text{
  padding: 35px 24px;
  box-sizing: border-box;
  width: 571px;
  max-width: 70%;
  opacity: 0.9;
  background: #000000;
  border-radius: 8px;
  font-size: 28px;
  font-family: Roboto, Roboto-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 28px;
  position: relative;
  z-index: 2003;
  word-break: keep-all;
}
/* loading */
.van-toast.van-toast--loading{
  width: 120px;
  height: 120px;
  font-size: 28px;
  font-family: Roboto, Roboto-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 28px;
}
.van-toast.van-toast--loading .van-toast__text{
  margin-top: 16px;
}
.van-toast.van-toast--loading .van-loading__spinner{
  width: 35px;
  height: 35px;
}
</style>

